import { Heading } from '../Heading/Heading'
import { Checkbox } from './Checkbox'
import { CHECKBOX_TYPES } from './Checkbox.constants'

export const CheckboxPresentation = () => {
  /* *** Standard Checkbox *** */

  const renderCheckbox = () =>
    CHECKBOX_TYPES.map(state => (
      <Checkbox
        id="id"
        label="Label"
        name="name"
        value="value"
        {...state}
        onChange={() => undefined}
      />
    ))

  return (
    <div>
      <Heading size={4}> Checkbox:</Heading>

      <Heading className="pt-4" size={6}>
        Standard
      </Heading>

      {/* *** Standard Checkbox *** */}

      <div className="d-flex pt-4 justify-content-evenly">
        {renderCheckbox()}
      </div>
    </div>
  )
}
